/*import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";*/

export default function DisabledComponent() {
  return null; // renders nothing
}

/* ---- ORIGINAL BELOW ----
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [lng, setLng] = useState(i18n.resolvedLanguage || i18n.language || "en");

  useEffect(() => {
    const handler = (l) => setLng(l);
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
  }, [i18n]);

  const change = (l) => () => {
    i18n.changeLanguage(l);
    try { localStorage.setItem("i18nextLng", l); } catch {}
  };

  const isRO = lng?.startsWith("ro");
  const isEN = lng?.startsWith("en");

  return (
    <div
      role="radiogroup"
      aria-label="Language"
      className="inline-flex items-center overflow-hidden rounded-xl border border-neutral-700"
    >
      <button
        role="radio"
        aria-checked={isRO}
        onClick={change("ro")}
        className={`px-3 py-1 text-sm font-semibold transition
          ${isRO ? "bg-white text-black" : "text-white hover:bg-white/10"}`}
      >
        RO
      </button>

      <div aria-hidden="true" className="h-5 w-px bg-neutral-700/80" />

      <button
        role="radio"
        aria-checked={isEN}
        onClick={change("en")}
        className={`px-3 py-1 text-sm font-semibold transition
          ${isEN ? "bg-white text-black" : "text-white hover:bg-white/10"}`}
      >
        EN
      </button>
    </div>
  );
}
---- END ORIGINAL ---- */